import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordField = ({ className = '', containerClassName = '', id, ...inputProps }) => {
  const [visible, setVisible] = useState(false);
  const actionLabel = visible ? 'Hide password' : 'Show password';

  return (
    <div className={`relative ${containerClassName}`}>
      <input
        {...inputProps}
        id={id}
        type={visible ? 'text' : 'password'}
        className={`${className} min-h-11 pr-12`}
      />
      <button
        type="button"
        aria-label={actionLabel}
        aria-pressed={visible}
        aria-controls={id}
        onClick={() => setVisible((current) => !current)}
        className="absolute inset-y-0 right-0 flex min-h-11 w-11 items-center justify-center rounded-r-md text-gray-500 transition hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 dark:text-gray-300 dark:hover:text-white"
      >
        {visible ? <FaEyeSlash aria-hidden="true" /> : <FaEye aria-hidden="true" />}
      </button>
    </div>
  );
};

export default PasswordField;
